<template>
  <div class="inputTextArea"
       id="inputTextArea"
       ref="textArea"
       :style="width?'width:'+width+'%':''"
       :contenteditable="canEdit"
       @focus="scrollTop"
       @blur="isLocked = false"
       @input="changeText"
       @keydown="downKey"
       @keyup="upKey"
  ></div>
</template>
<script>
import Util from '@/utils/dataUtil'

export default {
  name: 'editDiv',
  props: ['canEdit', 'width'],
  data() {
    return {
      isLocked: false
    }
  },
  methods: {
    IEVersion() {
      var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
        reIE.test(userAgent)
        var fIEVersion = parseFloat(RegExp['$1'])
        if (fIEVersion == 7) {
          return 7
        } else if (fIEVersion == 8) {
          return 8
        } else if (fIEVersion == 9) {
          return 9
        } else if (fIEVersion == 10) {
          return 10
        } else {
          return 6//IE版本<=7
        }
      } else if (isEdge) {
        return 'edge'//edge
      } else if (isIE11) {
        return 11 //IE11
      } else {
        return -1//不是ie浏览器
      }
    },
    changeText() {
      this.$emit('getAllContent', this.$el.innerHTML)
    },
    clearInnertext() {
      this.$el.innerHTML = ''
    },
    scrollTop() {
      this.$emit('scrollTop')
    },
    selectFile(e) {
      var files = e.target.files
    },
    textareaRange() {
      let el = this.$refs.textArea.childNodes;
      let rang = document.createRange()
      if (el.length >= 1) rang.selectNodeContents(el[el.length - 1])
      rang.collapse(false)
      let sel = document.getSelection()
      if (sel.anchorOffset != 0) return
      sel.removeAllRanges()
      sel.addRange(rang)
    },
    addChild(string, type) {
      this.$refs.textArea.appendChild(string)
      if (type == 0) {
        this.$el.innerHTML = string.innerHTML
      }
      this.$emit('getAllContent', this.$el.innerHTML)
      if (Util.isNotEmpty(this.$el.innerHTML)) {
        this.$refs.textArea.focus()
        this.textareaRange()
      }
    },
    //键盘 enter事件
    downKey(e) {
      let val = this.$el.innerHTML
      if (e.keyCode == 13 && e.ctrlKey) {
        e.preventDefault()
        // 按回车键发送
        if (Util.isNotBlank(val)) {
          // val = val.replace(/<div>|<\/div>/g, '')
          let keyEnter = {
            val: val,
            keyCode: e.keyCode,
            index: true
          }
          this.$emit('getAllContent', keyEnter)
        }
        return false
      }
    },
    upKey() {
      if (this.IEVersion() != -1) this.$emit('getAllContent', this.$el.innerHTML)
    }
  }
}
</script>
<style>
.inputTextArea {
  width: 100%;
  height: 80px;
  padding: 0 20px;
  font-size: 14px;
  overflow-y: scroll;
}
.inputTextArea::-webkit-scrollbar { /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.inputTextArea::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #eee;
}
.inputTextArea::-webkit-scrollbar-track { /*滚动条里面轨道*/
  border-radius: 10px;
  background: transparent;
}
</style>
